import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const HongKong: Country = {
    identifier: "HongKong",
    name: "Hong Kong",
    countryCode: "HK",
    group: CountryGroup.ASIA,
    isUNMember: false,
    flag: "🇭🇰",
    svgPath: "m 795.58175,398.3754 0.01,0.013 0.061,0.113 -0.019,0.126 0.114,0.061 0.028,0.125 -0.126,0.067 -0.007,0.146 -0.056,0.09 -0.362,-0.16 -0.298,-0.083 -0.269,0.033 -0.098,-0.094 -0.017,-0.097 0.31,-0.168 0.024,-0.084 0.008,-0.007 0.09,-0.086 0.134,-0.025 0.07,-0.042 0.183,0 0.112,0.033 0.108,0.039 z m -0.753,0.998 -0.338,0 -0.072,-0.03 -0.036,-0.064 0.12,-0.116 0.456,-0.16 -0.114,0.168 -0.016,0.202 z m 0.657,0 -0.069,0.046 -0.192,-0.22 -0.012,-0.072 0.148,-0.013 0.167,0.1 -0.01,0.091 -0.032,0.068 z",
}
